import { Line, Text } from 'components'
import { App as Application, Device } from 'native/core-plugin'
import { useEffect, useState } from 'react'

export default function OpenSourceLicense() {
  const [licenses, setLinceses] = useState([])

  useEffect(() => {
    const licenses = Device.os() === 'android' ? AndroidLicenses : IosLicense
    setLinceses(licenses)
  }, [])

  // prettier-ignore
  const ApacheLicense = ({copyRight}) => {
    return (
      <>
      {copyRight}
      <pre>{`
Licensed under the Apache License, Version 2.0 (the "License")
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

`}
  <a href="http://www.apache.org/licenses/LICENSE-2.0" target={'_blank'} rel="noreferrer">http://www.apache.org/licenses/LICENSE-2.0</a>
{`

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
        `}
      </pre>
      </>
    )
  }

  // prettier-ignore
  const MitLicense = ({copyRight}) => {
    return (
      <>
      {copyRight}
      <pre>{`
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.`}
      </pre>
      </>
    )
  }

  const AndroidLicenses = [
    // {
    //   name: 'Libiconv',
    //   version: '1.11',
    //   link: 'https://github.com/winlibs/libiconv',
    //   lincese: 'LGPL v2.1',
    //   copyRight: '',
    // },
    {
      name: 'retrofit',
      version: '2.9.0',
      link: 'https://github.com/winlibs/libiconv',
      lincese: 'Apache License 2.0',
      copyRight: 'Copyright 2013 Square, Inc.',
    },
    {
      name: 'okhttp',
      version: '4.9.0',
      link: 'https://square.github.io/okhttp/',
      lincese: 'Apache License 2.0',
      copyRight: 'Copyright 2019 Square, Inc.',
    },
    {
      name: 'logger',
      version: '2.2.0',
      link: 'https://github.com/orhanobut/logger',
      lincese: 'Apache License 2.0',
      copyRight: 'Copyright 2018 Orhan Obut',
    },
  ]
  const IosLicense = [
    {
      name: 'Alamofire',
      version: '5.7.1',
      link: 'https://github.com/Alamofire/Alamofire',
      lincese: 'MIT',
      copyRight: 'Copyright (c) 2014-2022 Alamofire Software Foundation (http://alamofire.org/)',
    },
    {
      name: 'CryptoSwift',
      version: '1.7.2',
      link: 'https://github.com/krzyzanowskim/CryptoSwift',
      lincese: 'Apache License 2.0',
      copyRight: 'Copyright (C) 2014-3099 Marcin Krzyżanowski <marcin.krzyzanowski@gmail.com>',
    },
    {
      name: 'swift-log',
      version: '1.11',
      link: 'https://github.com/apple/swift-log',
      lincese: 'Apache License 2.0',
      copyRight: '',
    },
    {
      name: 'SwiftJson',
      version: '1.5.2',
      link: 'https://github.com/SwiftyJSON/SwiftyJSON',
      lincese: 'MIT',
      copyRight: 'Copyright (c) 2017 Ruoyu Fu',
    },
    {
      name: 'Toast-Swift',
      version: '5.0.1',
      link: 'https://github.com/scalessec/Toast-Swift',
      lincese: 'MIT',
      copyRight: 'Copyright (c) 2015-2019 Charles Scalesse.',
    },
  ]

  return (
    <>
      <main>
        {/* todo: 팝업 헤더 */}
        <div className="wrapper">
          This application is Copyright @ CJ Freshway All rights reserved. The following sets forth attribution notices
          for third party software thar may be contained in this application.
        </div>

        <Line size="1" color="gray" />

        <ul className="wrapper basic-list lincese">
          {licenses.map((item) => (
            <li>
              <font size="5">
                {item.name} <font size={2}>{item.version}</font>
              </font>
              <br />
              <a href={item.link} target={'_blank'} rel="noreferrer">
                {item.link}
              </a>
              <Text>{item.lincese}</Text>
              <div style={{ width: '100%', overflowX: 'auto' }}>
                {item.lincese === 'MIT' && <MitLicense copyRight={item.copyRight} />}
                {item.lincese === 'Apache License 2.0' && <ApacheLicense copyRight={item.copyRight} />}
              </div>
            </li>
          ))}
        </ul>
      </main>
    </>
  )
}
